import { render, staticRenderFns } from "./gjjs.vue?vue&type=template&id=141d2ada&scoped=true&"
import script from "./gjjs.vue?vue&type=script&lang=js&"
export * from "./gjjs.vue?vue&type=script&lang=js&"
import style0 from "./gjjs.vue?vue&type=style&index=0&id=141d2ada&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141d2ada",
  null
  
)

export default component.exports